import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Col, Row, Form, FloatingLabel, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'; // Import the Select component
import GLOBALVAR from "../constants"; // Import GLOBALVAR constant
import LoadingSpinner from "../components/misc/LoadingSpinner";


function AddRepayment() {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id');
    const [paymentDate, setPaymentDate] = useState(null); // State to manage birthday
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState(null);
    const [modalBody, setModalBody] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errMessages, setErrMessages] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [paymentType, setPaymentType] = useState('');

    const [formData, setFormData] = useState({
        loanProcessingID: id?id:'',
        paymentDate: '',
        prNumber: '',
        orNumber: '',
        paymentType: '',
        chequeNumber: '',
        paidPrincipal: '',
        paidInterest: '',
        paidPenalty: '',
        paidOther: '',
        paidTotal: ''
    });
    

    const handleDateChange = (date) => {
        if(!date) return;

        setPaymentDate(date);
        const formattedDate = format(date, 'MM/dd/yyyy'); 
        handleChangeInput({ target: { name: "paymentDate", value: formattedDate } });
    };

    useEffect(() => {
        let source = axios.CancelToken.source();

        const fetchOptions = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loansearch?query=${value}`, {
                    cancelToken: source.token
                });
                const data = response.data;

                if (data && data.rows) {
                    const suggestions = data.rows.map(loans => ({
                        label: `${loans.applicant.lastName}, ${loans.applicant.firstName} ${loans.applicant.middleName} [${loans.loanProcessingType} - ₱${parseFloat(loans.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} - ${format(new Date(loans.dateGranted), 'MM/dd/yyyy')}]`,
                        value: loans.id
                    }));
                    setOptions(suggestions);
                } else {
                    console.error('Invalid response structure:', data);
                    setOptions([]);
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching suggestions:', error);
                }
            } finally {
                setLoading(false);
            }
        };
        
        if (id) {
            const fetchApplication = async () => {
                try {
                    setLoading(true);
                    const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/${id}`);
                    const loans = response.data;
                    const addtl = `[${loans.loanProcessingType} - ₱${parseFloat(loans.amountGranted).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} - ${format(new Date(loans.dateGranted), 'MM/dd/yyyy')}]`;

                    setValue(`${loans.applicant.lastName}, ${loans.applicant.firstName} ${loans.applicant.middleName} ${addtl}`);
                    setOptions([{ label: `${loans.applicant.lastName}, ${loans.applicant.firstName} ${loans.applicant.middleName} ${addtl}`, value: loans.id }]);
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        navigate('/dashboard');
                    } else {
                        console.error('Error retrieving loans:', error);
                    }
                } finally {
                    setLoading(false);
                }
            };
            fetchApplication();
        } else {
            fetchOptions();
        }

        return () => {
            source.cancel();
        };
    }, [id, value, navigate]);

    useEffect(() => {
        if (id && !hasLoaded) { 
            setFormData(prevFormData => ({ ...prevFormData, loanProcessingID: id }));
            setHasLoaded(true);
        }
    }, [id, hasLoaded]);


    const handleChange = (selectedOption) => {
        setValue(selectedOption ? selectedOption.label : '');
        setFormData({ ...formData, loanProcessingID: selectedOption.value });
    };

    const handlePaymentTypeChange = (e) => {
        setPaymentType(e.target.value);
        handleChangeInput(e);
    };

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowSpinner(true);

        console.log(formData);

        try {
            const response = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/payments/add`, formData);
            console.log(response.data.message); // Display the message returned from the server
            navigate(`/loans/${formData.loanProcessingID}`);
        } catch (error) {
            console.error('Error submitting form:', error);
            setModalHeader('Validation Error');
            setModalBody('');

            const errorsArray = error.response.data.error.split(',\n');
            const filteredErrors = errorsArray.map(error => error.replace('notNull Violation: ', '')).filter(error => error.trim() !== '');
            setErrMessages(filteredErrors);
            handleShow();
            setShowSpinner(false);
        }
    };

    return (
        <>
            {showSpinner && (<LoadingSpinner />)}
            <NavMain slug="add-repayment" parent="2" />
            <HeaderMain slug="add-repayment" />
            <div className="main-content">
                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalHeader}</Modal.Title>
                    </Modal.Header>
                    {errMessages && (
                        <Modal.Body>
                        <ul>
                        {errMessages.map((error, index) => (
                            <li key={index}>{error.trim().replace('Validation error: ', '')}</li>
                        ))}
                        </ul>
                        </Modal.Body>
                    )}
                    {!errMessages && (
                        <Modal.Body>
                        {modalBody}
                        </Modal.Body>
                    )}
                </Modal>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col>
                            <Select
                                options={options}
                                isLoading={loading}
                                onInputChange={setValue}
                                onChange={handleChange}
                                value={options.find(option => option.label === value)}
                                placeholder="Type a name..."
                                isDisabled={id ? true : false}
                                name="loanProcessingID"
                            />
                        </Col>
                    </Row>
                    <hr className="my-4"></hr>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingPrNumber" label="PR Number">
                                <Form.Control 
                                    type="text"
                                    placeholder="PR Number" 
                                    name="prNumber" 
                                    onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingOrNumber" label="OR Number">
                                <Form.Control 
                                    type="text"
                                    placeholder="OR Number" 
                                    name="orNumber" 
                                    onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingPaymentType" label="Payment Type">
                                <Form.Select 
                                    name="paymentType" 
                                    value={paymentType}
                                    onChange={handlePaymentTypeChange} 
                                    onBlur={handlePaymentTypeChange}
                                >
                                    <option value="">Select Payment Type</option>
                                    <option value="cash">Cash</option>
                                    <option value="cheque">Cheque</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                        {paymentType === 'cheque' && (
                            <Col>
                                <FloatingLabel controlId="floatingChequeNumber" label="Cheque Number">
                                    <Form.Control 
                                        type="text" 
                                        placeholder="Cheque Number" 
                                        name="chequeNumber" 
                                        onChange={handleChangeInput}
                                        required
                                    />
                                </FloatingLabel>
                            </Col>
                        )}
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingPaidPrincipal" label="Paid Principal">
                                <Form.Control 
                                    type="number" 
                                    step="0.01"
                                    placeholder="Paid Principal" 
                                    name="paidPrincipal" 
                                    onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingPaidInterest" label="Paid Interest">
                                <Form.Control 
                                    type="number" 
                                    step="0.01"
                                    placeholder="Paid Interest" 
                                    name="paidInterest" 
                                    onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingPaidPenalty" label="Paid Penalty">
                                <Form.Control 
                                    type="number" 
                                    step="0.01"
                                    placeholder="Paid Penalty" 
                                    name="paidPenalty" 
                                    onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <FloatingLabel controlId="floatingPaidOther" label="Paid Other">
                                <Form.Control 
                                    type="number" 
                                    step="0.01"
                                    placeholder="Paid Other" 
                                    name="paidOther" 
                                    onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel controlId="floatingPaidTotal" label="Paid Total">
                                <Form.Control 
                                    type="number" 
                                    step="0.01"
                                    placeholder="Paid Total" 
                                    name="paidTotal" 
                                    onChange={handleChangeInput}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col>
                        {paymentDate ? (
                            <DatePicker
                            className="form-control"
                            selected={paymentDate} // Set the selected date
                            onChange={(e) => {
                                handleDateChange(e);
                            }} // Handle date change
                            dateFormat="MM/dd/yyyy" // Date format
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            name="paymentDate"
                            />
                        ) : (
                            <FloatingLabel controlId="floatingPaymentDate" label="Payment Date">
                            <DatePicker
                                className="form-control"
                                selected={paymentDate} // Set the selected date
                                onChange={(e) => {
                                    handleDateChange(e);
                                }} // Handle date change
                                dateFormat="MM/dd/yyyy" // Date format
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                name="paymentDate"
                                />
                            </FloatingLabel>
                        )}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Button variant="primary" type="submit" className="submit-btn" id="submit-processing">
                                Process Payment
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
}

export default AddRepayment;